export default "__VITE_ASSET__BJhHTnWd__"